import { render, staticRenderFns } from "./_newRelatedOrganization.vue?vue&type=template&id=a7bb6872&"
import script from "./_newRelatedOrganization.vue?vue&type=script&lang=js&"
export * from "./_newRelatedOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports